import { isOutcomeEphemeral } from 'flow/service/outcomes/outcomes';
import { ActionType } from '../constants';
import type { Action, SchemaInstance, WorkflowProps } from '../types';
import { getActionPublishedAttributeToken, getTagActionsByTagName } from 'flow/service/actions';
import { isTagEphemeral } from 'flow/service/tags/tags';
import { getActionsByPublishedAttributeToken, isPublishedAttributeEphemeral } from 'flow/service/publishedAttributes';

export function modifyRelevantPropsFromActionRemoval({
  actionToRemove,
  workflowProps,
  workflowActions,
}: {
  actionToRemove: Action;
  workflowProps: WorkflowProps;
  workflowActions: Partial<SchemaInstance>['actions'];
}) {
  switch (actionToRemove.type) {
    case ActionType.TAG: {
      const { tag: { name } } = actionToRemove;
      const isTagInWorkflow = getTagActionsByTagName(
        workflowActions,
        name,
      ).filter(action => action.publicId !== actionToRemove.publicId).length > 0;
      if (!isTagInWorkflow) {
        workflowProps.tags = workflowProps.tags.filter(
          tag => !(isTagEphemeral(tag) && tag.tag_name === name),
        );
      }
      break;
    }
    case ActionType.OUTCOME: {
      const { outcome: { name } } = actionToRemove;
      workflowProps.outcomes = workflowProps.outcomes.filter(
        outcome => !(isOutcomeEphemeral(outcome) && outcome.outcome === name));
      break;
    }
    case ActionType.INPUT:
    case ActionType.OUTPUT: {
      const paToken = getActionPublishedAttributeToken(actionToRemove);
      // check if PA is used elsewhere (can be used by both input + output in same WF)
      const connectedActions = getActionsByPublishedAttributeToken(workflowActions, paToken)
        .filter(action => action.publicId !== actionToRemove.publicId);
      // only remove if actionToRemove is the only connected action
      if (connectedActions.length === 0) {
        workflowProps.publishedAttributes = workflowProps.publishedAttributes.filter(
          pa => !(isPublishedAttributeEphemeral(pa) && pa.attributeToken === paToken),
        );
      }

      break;
    }
  }
}
